<template>
	<div class="uv-date-range" :class="{
		'uv-date-range--small': size === 'small',
		'uv-date-range--large': size === 'large'
	}">
		<el-date-picker v-model="startDate" :size="size" :type="dateType" :disabled-date="disableAfterEnd"
			:format="valueFormat" :value-format="valueFormat" :disabled="disabled" :clearable="clearable"
			:placeholder="startPlaceholder" class="date-field start" />

		<div class="separator">{{ rangeSeparator }}</div>

		<el-date-picker v-model="endDate" :size="size" :type="dateType" :disabled-date="disableBeforeStart"
			:format="valueFormat" :value-format="valueFormat" :disabled="disabled" :clearable="clearable"
			:placeholder="endPlaceholder" @clear="handleClear" class="date-field end" />
	</div>
</template>

<script setup>
	const props = defineProps({
		modelValue: {
			type: Array,
			default: () => ['', '']
		},
		rangeSeparator: {
			type: String,
			default: '-'
		},
		dateType: {
			type: String,
			default: 'date'
		},
		size: {
			type: String
		},
		startPlaceholder: {
			type: String,
			default: '开始日期'
		},
		endPlaceholder: {
			type: String,
			default: '结束日期'
		},
		clearable: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		valueFormat: {
			type: String,
			default: 'YYYY-MM-DD'
		}
	})

	const emits = defineEmits(['update:modelValue'])

	/**
	 * 用 computed 直接代理 modelValue
	 * 避免 watch 循环 & 状态抖动
	 */
	const startDate = computed({
		get: () => props.modelValue?.[0] || '',
		set: (val) => {
			emits('update:modelValue', [val, props.modelValue?.[1] || ''])
		}
	})

	const endDate = computed({
		get: () => props.modelValue?.[1] || '',
		set: (val) => {
			emits('update:modelValue', [props.modelValue?.[0] || '', val])
		}
	})

	/**
	 * 禁用逻辑：语义清晰
	 */
	const disableBeforeStart = (date) => {
		if (!date || !startDate.value) return false
		return date.getTime() < new Date(startDate.value).getTime()
	}

	const disableAfterEnd = (date) => {
		if (!date || !endDate.value) return false
		return date.getTime() > new Date(endDate.value).getTime()
	}

	/**
	 * 清空时统一清空区间
	 */
	const handleClear = () => {
		emits('update:modelValue', ['', ''])
	}
</script>


<style lang="scss" scoped>
	.uv-date-range {
		display: flex;
		align-items: center;
		border-radius: var(--el-border-radius-base);
		box-shadow: 0 0 0 1px var(--el-border-color) inset;
		padding: 0 2px;
		
		&.uv-date-range--small {
			height: var(--el-component-size-small);
		}
		
		&.uv-date-range--large {
			height: var(--el-component-size-large);
			
			:deep(.date-field) {
				font-size: 14px;
			}
		}

		.separator {
			color: var(--el-text-color-secondary);
			user-select: none;
		}

		:deep(.date-field) { 
			width: 100%;
			height: calc(var(--el-input-height, var(--el-component-size)) - 2px);
			
			.el-input__wrapper {
				box-shadow: none;
				padding: 1px 4px 1px 8px; 
				
				.el-input__prefix {
					display: none;
				}
			} 
		}
	}
</style>